// The student check-in in the school's extra home languages (J10, 0018):
// Arabic, Somali, Russian and Ukrainian. DRAFT machine-assisted translations,
// shown with a "Draft translation" label until a native speaker reviews
// them. Only the check-in is translated; staff screens stay EN/FI/SV.
// The school's own safety-net message is always shown alongside.

export type StudentLang = 'ar' | 'so' | 'ru' | 'uk';

export const STUDENT_LANGS: { code: StudentLang; name: string; dir: 'ltr' | 'rtl' }[] = [
  { code: 'ar', name: 'العربية', dir: 'rtl' },
  { code: 'so', name: 'Soomaali', dir: 'ltr' },
  { code: 'ru', name: 'Русский', dir: 'ltr' },
  { code: 'uk', name: 'Українська', dir: 'ltr' },
];

type S = Record<string, string>;

export const STUDENT_STRINGS: Record<StudentLang, S> = {
  ar: {
    'lang.label': 'اللغة',
    loading: 'جارٍ التحميل…',
    'a11y.link': 'بيان إمكانية الوصول',
    'ci.pageTitle': 'تسجيل الحال',
    'ci.title': 'كيف حالك اليوم؟',
    'ci.anon': 'بدون اسم — يرى معلمك المجموع للصف كله فقط.',
    'ci.scaleHint': '1 هو الأدنى و5 هو الأعلى.',
    'ci.topicsTitle': 'هل يشغل بالك شيء؟',
    'ci.topicsHint': 'اختياري — اختر ما تشاء.',
    'ci.done': 'تم',
    'ci.sending': 'جارٍ الإرسال…',
    'ci.pickFirst': 'اختر وجهًا من 1 إلى 5 للمتابعة.',
    'ci.error': 'لم يتم الإرسال. اسأل معلمك إن كان التسجيل لا يزال مفتوحًا.',
    'ci.closedTitle': 'هذا التسجيل غير مفتوح الآن',
    'ci.closedBody': 'اطلب من معلمك رابط اليوم أو رمز QR.',
    'ci.doneTitle': 'شكرًا — تم تسجيلك',
    'ci.doneBody': 'لا شيء آخر. يمكنك إغلاق هذه الصفحة.',
    'ci.youSaid': 'من معلمك',
    'ci.schoolSaid': 'من مدرستك',
    'ci.draftTranslation': 'ترجمة مسودة',
    'r4b.ci.concernTitle': 'هل تريد أن تقول المزيد؟',
    'r4b.ci.concernHint': 'اختياري — اختر ما تشاء، أو لا شيء.',
    'r4b.ci.onYourMind': 'هل هذا في بالك اليوم؟',
    'r4b.ci.onMyMind': 'في بالي',
    'r4b.ci.notReally': 'ليس حقًا',
    'r4b.ci.nothingElse': 'لا شيء آخر',
    'r4b.ci.back': '← رجوع',
    'r4b.ci.next': 'التالي',
    'concern.left_out_or_bullied': 'الشعور بالعزلة أو التنمر',
    'concern.online_and_phone': 'الإنترنت والهاتف',
    'concern.body_or_looks': 'الجسد أو المظهر',
    'concern.the_future': 'المستقبل',
    'concern.hobbies_or_sport': 'الهوايات أو الرياضة',
    'concern.money': 'المال',
    'concern.unspecified': 'أفضل عدم القول',
    'safety.label': 'معلومات الدعم',
    'mood.1': 'صعب جدًا',
    'mood.2': 'ليس جيدًا',
    'mood.3': 'لا بأس',
    'mood.4': 'جيد',
    'mood.5': 'ممتاز',
    'topic.schoolwork': 'الدراسة',
    'topic.friends': 'الأصدقاء',
    'topic.family': 'العائلة',
    'topic.sleep': 'النوم',
    'topic.health': 'الصحة',
    'topic.exams': 'الامتحانات',
    'topic.other': 'شيء آخر',
  },
  so: {
    'lang.label': 'Luqadda',
    loading: 'Waa la soo rarayaa…',
    'a11y.link': 'Bayaanka helitaanka',
    'ci.pageTitle': 'Is-diiwaangelin',
    'ci.title': 'Sidee tahay maanta?',
    'ci.anon': 'Magac la’aan — macallinkaagu wuxuu arkaa oo keliya wadarta fasalka oo dhan.',
    'ci.scaleHint': '1 waa ka ugu hooseeya, 5 waa ka ugu sarreeya.',
    'ci.topicsTitle': 'Ma jiraa wax maskaxdaada ku jira?',
    'ci.topicsHint': 'Ikhtiyaari — dooro inta aad rabto.',
    'ci.done': 'Dhammaad',
    'ci.sending': 'Waa la dirayaa…',
    'ci.pickFirst': 'Dooro waji 1 ilaa 5 si aad u sii wadato.',
    'ci.error': 'Ma gudbin. Weydii macallinkaaga haddii is-diiwaangelintu weli furan tahay.',
    'ci.closedTitle': 'Is-diiwaangelintan hadda ma furna',
    'ci.closedBody': 'Weydii macallinkaaga xiriirka maanta ama koodka QR.',
    'ci.doneTitle': 'Mahadsanid — waad is-diiwaangelisay',
    'ci.doneBody': 'Wax kale ma jiraan. Waad xiri kartaa boggan.',
    'ci.youSaid': 'Macallinkaaga',
    'ci.schoolSaid': 'Dugsigaaga',
    'ci.draftTranslation': 'Tarjumaad qabyo ah',
    'r4b.ci.concernTitle': 'Ma sheegi kartaa wax dheeraad ah?',
    'r4b.ci.concernHint': 'Ikhtiyaari — dooro inta aad rabto, ama midna.',
    'r4b.ci.onYourMind': 'Ma waxaan maanta ku fikiraysaa tan?',
    'r4b.ci.onMyMind': 'Waan ku fikirayaa',
    'r4b.ci.notReally': 'Runtii maya',
    'r4b.ci.nothingElse': 'Wax kale ma jiro',
    'r4b.ci.back': '← Dib',
    'r4b.ci.next': 'Xiga',
    'concern.left_out_or_bullied': 'In laga tagay ama la dulmiyo',
    'concern.online_and_phone': 'Internetka iyo taleefanka',
    'concern.body_or_looks': 'Jirka ama muuqaalka',
    'concern.the_future': 'Mustaqbalka',
    'concern.hobbies_or_sport': 'Hobbiyada ama ciyaaraha',
    'concern.money': 'Lacagta',
    'concern.unspecified': 'Ma doonayo inaan sheego',
    'safety.label': 'Macluumaadka taageerada',
    'mood.1': 'Aad u adag',
    'mood.2': 'Ma fiicna',
    'mood.3': 'Caadi',
    'mood.4': 'Fiican',
    'mood.5': 'Aad u fiican',
    'topic.schoolwork': 'Waxbarasho',
    'topic.friends': 'Saaxiibo',
    'topic.family': 'Qoys',
    'topic.sleep': 'Hurdo',
    'topic.health': 'Caafimaad',
    'topic.exams': 'Imtixaanno',
    'topic.other': 'Wax kale',
  },
  ru: {
    'lang.label': 'Язык',
    loading: 'Загрузка…',
    'a11y.link': 'Заявление о доступности',
    'ci.pageTitle': 'Опрос',
    'ci.title': 'Как у тебя дела сегодня?',
    'ci.anon': 'Анонимно — учитель видит только итоги по всему классу.',
    'ci.scaleHint': '1 — самая низкая оценка, 5 — самая высокая.',
    'ci.topicsTitle': 'Что-то занимает твои мысли?',
    'ci.topicsHint': 'Необязательно — выбери сколько хочешь.',
    'ci.done': 'Готово',
    'ci.sending': 'Отправка…',
    'ci.pickFirst': 'Выбери лицо от 1 до 5, чтобы продолжить.',
    'ci.error': 'Не отправилось. Спроси учителя, открыт ли ещё опрос.',
    'ci.closedTitle': 'Этот опрос сейчас закрыт',
    'ci.closedBody': 'Попроси у учителя сегодняшнюю ссылку или QR-код.',
    'ci.doneTitle': 'Спасибо — ты отметился(-ась)',
    'ci.doneBody': 'Больше ничего не нужно. Можно закрыть страницу.',
    'ci.youSaid': 'От твоего учителя',
    'ci.schoolSaid': 'От твоей школы',
    'ci.draftTranslation': 'Черновой перевод',
    'r4b.ci.concernTitle': 'Можешь рассказать подробнее?',
    'r4b.ci.concernHint': 'Необязательно — выбери сколько хочешь, или ничего.',
    'r4b.ci.onYourMind': 'Думаешь об этом сегодня?',
    'r4b.ci.onMyMind': 'Да, думаю',
    'r4b.ci.notReally': 'Не особо',
    'r4b.ci.nothingElse': 'Больше ничего',
    'r4b.ci.back': '← Назад',
    'r4b.ci.next': 'Далее',
    'concern.left_out_or_bullied': 'Чувство изоляции или травля',
    'concern.online_and_phone': 'Интернет и телефон',
    'concern.body_or_looks': 'Тело или внешность',
    'concern.the_future': 'Будущее',
    'concern.hobbies_or_sport': 'Хобби или спорт',
    'concern.money': 'Деньги',
    'concern.unspecified': 'Не хочу говорить',
    'safety.label': 'Где получить помощь',
    'mood.1': 'Очень тяжело',
    'mood.2': 'Не очень',
    'mood.3': 'Нормально',
    'mood.4': 'Хорошо',
    'mood.5': 'Отлично',
    'topic.schoolwork': 'Учёба',
    'topic.friends': 'Друзья',
    'topic.family': 'Семья',
    'topic.sleep': 'Сон',
    'topic.health': 'Здоровье',
    'topic.exams': 'Экзамены',
    'topic.other': 'Другое',
  },
  uk: {
    'lang.label': 'Мова',
    loading: 'Завантаження…',
    'a11y.link': 'Заява про доступність',
    'ci.pageTitle': 'Опитування',
    'ci.title': 'Як ти сьогодні?',
    'ci.anon': 'Анонімно — учитель бачить лише підсумки для всього класу.',
    'ci.scaleHint': '1 — найнижча оцінка, 5 — найвища.',
    'ci.topicsTitle': 'Щось не виходить з голови?',
    'ci.topicsHint': 'Необов’язково — обери скільки хочеш.',
    'ci.done': 'Готово',
    'ci.sending': 'Надсилання…',
    'ci.pickFirst': 'Обери обличчя від 1 до 5, щоб продовжити.',
    'ci.error': 'Не надіслалося. Запитай учителя, чи опитування ще відкрите.',
    'ci.closedTitle': 'Це опитування зараз закрите',
    'ci.closedBody': 'Попроси в учителя сьогоднішнє посилання або QR-код.',
    'ci.doneTitle': 'Дякуємо — тебе відмічено',
    'ci.doneBody': 'Більше нічого не потрібно. Можна закрити сторінку.',
    'ci.youSaid': 'Від твого вчителя',
    'ci.schoolSaid': 'Від твоєї школи',
    'ci.draftTranslation': 'Чорновий переклад',
    'r4b.ci.concernTitle': 'Можеш розповісти детальніше?',
    'r4b.ci.concernHint': 'Необов’язково — обери скільки хочеш, або нічого.',
    'r4b.ci.onYourMind': 'Думаєш про це сьогодні?',
    'r4b.ci.onMyMind': 'Так, думаю',
    'r4b.ci.notReally': 'Не особливо',
    'r4b.ci.nothingElse': 'Більше нічого',
    'r4b.ci.back': '← Назад',
    'r4b.ci.next': 'Далі',
    'concern.left_out_or_bullied': 'Відчуття самотності або булінг',
    'concern.online_and_phone': 'Інтернет і телефон',
    'concern.body_or_looks': 'Тіло або зовнішність',
    'concern.the_future': 'Майбутнє',
    'concern.hobbies_or_sport': 'Хобі або спорт',
    'concern.money': 'Гроші',
    'concern.unspecified': 'Не хочу казати',
    'safety.label': 'Де отримати допомогу',
    'mood.1': 'Дуже важко',
    'mood.2': 'Не дуже',
    'mood.3': 'Нормально',
    'mood.4': 'Добре',
    'mood.5': 'Чудово',
    'topic.schoolwork': 'Навчання',
    'topic.friends': 'Друзі',
    'topic.family': 'Родина',
    'topic.sleep': 'Сон',
    'topic.health': 'Здоров’я',
    'topic.exams': 'Іспити',
    'topic.other': 'Інше',
  },
};
